import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormControl, Select, MenuItem, InputLabel } from "@mui/material";
import PackagingPlantMasterTable from "./PackagingPlantMasterTable";
import btnDownloadIcon from "../../../Assests/download-icon.svg";
import btnSaveIcon from "../../../Assests/Save-btn.svg";
import {
  EditProductTableSuccess,
  ViewProductTableError,
  ViewProductTableStart,
  ViewProductTableSuccess,
  enableEditFilter,
  loadCascadeOptions,
} from "../../../Redux/Actions/InputData";
import { postRequest, putRequest } from "../../../Services/AxiosConfiguration";
import {
  API_BASE_URL,
  BULK_EDIT_MANUFACTURING_MASTER_TABLE_API,
  DISPLAY_MANUFACTURING_MASTER_1_TABLE_API,
  DOWNLOAD_MANUFACTURING_MASTER_1_TABLE_API,
  LONG_PACKAGING_PLANT_DOWNLOAD_API,
  LONG_PACKAGING_PLANT_GET_API,
  LONG_FACILITY_MASTER_GET_API,
  VIEW_MANUFACTURING_MASTER_1_TABLE_API,
  LONG_BULK_EDIT_PACK_PLANT_API,
} from "../../../Utils/Config";
import RestoreOutlinedIcon from "@mui/icons-material/RestoreOutlined";
import axios from "axios";
import FileSaver from "file-saver";
import "./style.css";
import { useTheme } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import Snackbar from "@mui/material/Snackbar";
import Alert, { AlertProps } from "@mui/material/Alert";

import AddRowButton from "../../../Components/Common/AddRowButton";
import DeleteRowsButton from "../../../Components/Common/DeleteRowsButton";
import ConfirmationDialog from "../../../Components/Common/ConfirmationDialog";

function PackagingPlantMaster(props: any) {
  const childRef: any = useRef();
  const dispatch: any = useDispatch();
  const [selectPackagingPlantCode, setPackagingPlantCode] = useState<any>("");
  const [selectFormat, setFormat] = useState<any>("");
  const [selectPackingPlantDesc, setPackingPlantDesc] = useState<any>("");
  const [selectCascade, setCascade] = useState<any>("");
  const [selectProductDesc, setProductDesc] = useState<any>("");
  const [selectTimePeriod, setTimePeriod] = useState<any>("");
  const [rowsData, setRows] = React.useState<any[]>([]);
  const [isProcessed, setIsProcessed] = React.useState(false);
  const [packagingPlantCodeOptions, setPackagingPlantCodeOptions] =
    React.useState([]);
  const [packagingPlantDescOptions, setPackagingPlantDescOptions] =
    React.useState([]);

  const [productCodeOptions, setProductCodeOptions] = useState<any>([]);
  const [flagOptions, setFlagOptions] = useState<any>([]);
  const [selectProductCode, setProductCode] = useState<any>("");
  const [cascadeOptions, setCascadeOptions] = useState<any>([]);
  const [timePeriodOptions, settimePeriodOptions] = useState<any>([]);
  const [getEditedValue, setEditedValue] = useState<any>([]);
  const [open, setOpen] = React.useState(false);

  const [filterRequest, setFilterRequest] = React.useState([
    { key: "packaging_Plant_Code", value: "" },
    { key: "[cascade]", value: "" },
    { key: "product_code", value: "" },
    { key: "time_Period", value: "" },
  ]);

  const sortedPackaingPlantCode = packagingPlantCodeOptions?.sort(
    (a: any, b: any) =>
      a?.packaging_Plant_Code.localeCompare(b?.packaging_Plant_Code),
  );

  const selectedFolderData = useSelector(
    (state: any) => state.InputDataReducers.selectedFolderData,
  );
  const selectedUsecaseId = useSelector(
    (state: any) => state.InputDataReducers.selectedUsecaseId,
  );
  const selectedCategoryId = useSelector(
    (state: any) => state.InputDataReducers.selectedCategoryId,
  );

  const selectedFolderId = useSelector(
    (state: any) => state.InputDataReducers.selectedFolderId,
  );

  const selectedScenarioId = useSelector(
    (state: any) => state.InputDataReducers.selectedScenarioId,
  );

  const isEditPopup = useSelector(
    (state: any) => state.InputDataReducers.editPopupFlage,
  );
  const selectedTimePeriodData = useSelector(
    (state: any) => state.InputDataReducers.selectedTimePeriodData,
  );

  let folderModuleName = selectedFolderData?.folder?.slice(0, 7);
  const [tableName, setTableName] = useState<any>(
    "tblScenario_PackagingPlant_LT",
  );

  const [isDeleteConfirmOpen, setIsDeleteConfirmOpen] = useState(false);
  const [deletedRows, setDeletedRows] = useState<any[]>([]);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [isActionEnabled, setIsActionEnabled] = useState(false);
  const handleSelectionChange = (newSelection: any[]) => {
    setSelectedRows(newSelection);
    setIsActionEnabled(newSelection.length > 0);
  };

  useEffect(() => {
    if (folderModuleName === "module2") {
      setTableName("tblScenario_PackagingPlant_LT_Module2");
      callTableGridApi("tblScenario_PackagingPlant_LT_Module2");
    } else if (folderModuleName === "module3") {
      setTableName("tblScenario_PackagingPlant_LT_Module3");
      callTableGridApi("tblScenario_PackagingPlant_LT_Module3");
    } else if (folderModuleName === "module4") {
      setTableName("tblScenario_PackagingPlant_LT_Module4");
      callTableGridApi("tblScenario_PackagingPlant_LT_Module4");
    } else if (folderModuleName === "module5") {
      setTableName("tblScenario_PackagingPlant_LT_Module5");
      callTableGridApi("tblScenario_PackagingPlant_LT_Module5");
    } else if (folderModuleName === "module6") {
      setTableName("tblScenario_PackagingPlant_LT_Module6");
      callTableGridApi("tblScenario_PackagingPlant_LT_Module6");
    } else {
      setTableName("tblScenario_PackagingPlant_LT");
      callTableGridApi("tblScenario_PackagingPlant_LT");
    }
  }, [folderModuleName, selectedScenarioId]);

  var pacCode = 0;
  var cas = 0;
  var proCode = 0;
  var timeP = 0;

  const handlePackagingPlantCode = (event: any) => {
    setCascade("");
    setProductCode("");
    setTimePeriod("");
    filterRequest[1].value = "";
    filterRequest[2].value = "";
    filterRequest[3].value = "";
    const {
      target: { value },
    } = event;
    setPackagingPlantCode(value);
    filterRequest[0].value = value;
    callTableGridApi();
    pacCode = 1;
    cas = 0;
    proCode = 0;
    timeP = 0;
  };

  const handleCascade = (event: any) => {
    setProductCode("");
    setTimePeriod("");
    filterRequest[2].value = "";
    filterRequest[3].value = "";
    const {
      target: { value },
    } = event;
    setCascade(value);
    filterRequest[1].value = value;
    callTableGridApi();
    pacCode = 1;
    cas = 1;
    proCode = 0;
    timeP = 0;
  };

  const handleProductCode = (event: any) => {
    setTimePeriod("");
    filterRequest[3].value = "";
    const {
      target: { value },
    } = event;
    setProductCode(value);
    filterRequest[2].value = value;
    callTableGridApi();
    pacCode = 1;
    cas = 1;
    proCode = 1;
    timeP = 0;
  };

  const handleTimePeriod = (event: any) => {
    pacCode = 1;
    cas = 1;
    proCode = 1;
    timeP = 1;
    const {
      target: { value },
    } = event;
    setTimePeriod(value);
    filterRequest[3].value = value;
    callTableGridApi();
  };

  const handleDownload = (e: any) => {
    downloadXLSFile();
  };

  const downloadXLSFile = async () => {
    const filterList = filterRequest.filter((elem: any) => elem.value != "");
    const requestParam = {
      usecaseId: 0,
      category_id: 0,
      folder_id: selectedFolderId,
      scenario_id: selectedScenarioId,
      table: tableName,
      time_period: "string",
      filter: filterList,
    };
    // const requestParam = { "folder_id": selectedFolderId, "scenario_id": selectedScenarioId, "table": "tblManufacturing1Data", "filter": filterList };
    const urls = API_BASE_URL + LONG_PACKAGING_PLANT_DOWNLOAD_API;
    axios({
      url: urls,
      method: "post",
      responseType: "arraybuffer",
      headers: { "Content-Type": "application/json;" },
      data: requestParam,
    }).then((response) => {
      let blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      FileSaver(blob, Date.now() + ".xlsx");
    });
  };

  useEffect(() => {
    callTableGridApi();
  }, [
    selectedUsecaseId,
    selectedCategoryId,
    selectedFolderId,
    selectedScenarioId,
    selectedTimePeriodData,
  ]);
  const callTableGridApi = (selectedTable?: any) => {
    let timePeriodValues =
      selectedTimePeriodData !== undefined &&
      selectedTimePeriodData &&
      selectedTimePeriodData !== "Time Period" &&
      selectedTimePeriodData?.length > 0 &&
      selectedTimePeriodData[0] !== "Time Period" &&
      selectedTimePeriodData !== ""
        ? selectedTimePeriodData.join(",")
        : "";
    const filterList = filterRequest.filter((elem: any) => elem.value != "");

    console.log(selectedScenarioId, "scenario2");
    let scenarioId =
      selectedScenarioId?.scenario_id !== undefined &&
      selectedScenarioId?.scenario_id !== ""
        ? selectedScenarioId
        : selectedScenarioId;
    const requestParam = {
      folder_id: selectedFolderId,
      scenario_id: scenarioId,
      //  table: scenarioId === 0
      //  ? "tblManufacturingMaster"
      //  : "tblManufacturingMaster_HC_Rerun",
      table: selectedTable ?? tableName,
      ispagination: 1,
      page: 1,
      pagesize: 100,
      filter: filterList,
      time_period: timePeriodValues,
    };

    console.log(requestParam, "params");

    dispatch(ViewProductTableStart());
    const urls = API_BASE_URL + LONG_PACKAGING_PLANT_GET_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    postRequest(urls, requestParam, header, {})
      .then((response) => {
        if (response.status === 200 && response.data) {
          setIsProcessed(true);
          setRows(response.data);
          if (pacCode == 0) {
            setPackagingPlantCodeOptions(loadPackagingPlantCode(response.data));
          }
          if (cas === 0) setCascadeOptions(loadCascades(response.data));
          if (proCode === 0)
            setProductCodeOptions(loadProductCode(response.data));
          if (timeP === 0) settimePeriodOptions(loadTimePeriod(response.data));

          dispatch(ViewProductTableSuccess(response.data));
        }
      })
      .catch((error) => {
        // dispatch(openErrorDialog(error));
        dispatch(ViewProductTableError(error));
      });
  };

  const loadPackagingPlantCode = (data: any) => {
    const packagingPlantCode: any = [];
    data.map((item: any) => {
      const filteredItem = packagingPlantCode.find((obj: any) => {
        return obj.packaging_Plant_Code === item.packaging_Plant_Code;
      });
      if (filteredItem === undefined || filteredItem == null) {
        packagingPlantCode.push({
          id: item.id,
          packaging_Plant_Code: item.packaging_Plant_Code,
        });
      }
    });
    return packagingPlantCode;
  };

  const loadCascades = (data: any) => {
    const cascadeOptions: any = [];
    data.map((item: any) => {
      const filteredItem = cascadeOptions.find((obj: any) => {
        return obj.cascade === item.cascade;
      });
      if (filteredItem === undefined || filteredItem == null) {
        cascadeOptions.push({ id: item.id, cascade: item.cascade });
      }
    });
    return cascadeOptions;
  };

  const loadProductCode = (data: any) => {
    const productCode: any = [];
    data.map((item: any) => {
      const filteredItem = productCode.find((obj: any) => {
        return obj.product_Code === item.product_Code;
      });
      if (filteredItem === undefined || filteredItem == null) {
        productCode.push({ id: item.id, product_Code: item.product_Code });
      }
    });
    return productCode;
  };

  const loadTimePeriod = (data: any) => {
    const timePeriod: any = [];
    data.map((item: any) => {
      const filteredItem = timePeriod.find((obj: any) => {
        return obj.time_Period === item.time_Period;
      });
      if (filteredItem === undefined || filteredItem == null) {
        timePeriod.push({ id: item.id, time_Period: item.time_Period });
      }
    });
    return timePeriod;
  };

  const getfiltersApi = (tableeName?: string) => {
    const filterList = filterRequest.filter((elem: any) => elem.value != "");
    //const requestParam = { "folder_id": selectedFolderId, "scenario_id": selectedScenarioId, "table": "tblManufacturing1Data", "ispagination": 1, "page": 1, "pagesize": 100, "filter": filterList };
    // const requestParam = { "usecaseId": selectedUsecaseId, "category_id": selectedCategoryId,"folder_id": selectedFolderId, "scenario_id": selectedScenarioId, "table": selectedScenarioId > 0 ? "tblManufacturingMaster_HC_Rerun" : "tblManufacturingMaster", "time_period": "string","ispagination": 1, "page": 1, "pagesize": 100, "filter": filterList };
    let scenarioId =
      selectedScenarioId?.scenario_id !== undefined &&
      selectedScenarioId?.scenario_id !== ""
        ? selectedScenarioId?.scenario_id
        : selectedScenarioId;
    const requestParam = {
      folder_id: selectedFolderId,
      scenario_id: scenarioId,
      table: tableeName ?? tableName,
      ispagination: 1,
      page: 1,
      pagesize: 100,
      filter: filterList,
      time_period: "",
    };

    dispatch(ViewProductTableStart());
    const urls = API_BASE_URL + LONG_PACKAGING_PLANT_GET_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    postRequest(urls, requestParam, header, {})
      .then((response) => {
        if (response.status === 200 && response.data) {
          setPackagingPlantCodeOptions(loadPackagingPlantCode(response.data));
          setCascadeOptions(loadCascades(response.data));
          setProductCodeOptions(loadProductCode(response.data));
          settimePeriodOptions(loadTimePeriod(response.data));
        }
      })
      .catch((error) => {
        // dispatch(openErrorDialog(error));
        dispatch(ViewProductTableError(error));
      });
  };

  // useEffect(() => {
  //   callTableGridApi();
  //   getfiltersApi();
  // }, [selectedFolderId, selectedScenarioId, tableName]);

  const handleRestoreClicked = (e: any) => {
    setPackagingPlantCode("");
    setCascade("");
    setProductCode("");
    setTimePeriod("");
    filterRequest[0].value = "";
    filterRequest[1].value = "";
    filterRequest[2].value = "";
    filterRequest[3].value = "";
    callTableGridApi(tableName);
  };

  //need to update the actual columns
  const handleAddRow = () => {
    setRows((prev: any) => {
      const emptyRow = {
        id: new Date().getTime(),
        folder_Id: selectedFolderId,
        scenario_id: selectedScenarioId,
        packaging_Plant_Code: "",
        packaging_Plant_Description: "",
        cascade: "",
        format: "",
        product_Code: "",
        product_Description: "",
        time_Period: "",
        utilization_Perc: "",
        speed: 0,
        min_Capacity: "",
        max_Capacity: "",
        cpt: 0,
        step_1_Vol: "",
        step_1_Cost: "",
        step_2_Vol: "",
        step_2_Cost: "",
        step_3_Vol: "",
        step_3_Cost: "",
        step_4_Vol: "",
        step_4_Cost: "",
        step_5_Vol: "",
        step_5_Cost: "",
        lead_Time: "",
        cO2: "",
        isNew: true,
      };
      return prev.length > 0 ? [...prev, emptyRow] : prev;
    });
  };
  // bulk edit

  const handleClearEditData = (val: any) => {
    console.log(val, "edited array");
  };

  const isEditEnabled = useSelector(
    (state: any) => state.InputDataReducers.editFilterEnable,
  );

  const handleFetchEditData = (val: any) => {
    console.log(val, "edited array");
    setEditedValue(val);
  };

  const handleEditSave = (e: any) => {
    const requiredFields = [
      "packaging_Plant_Code",
      "packaging_Plant_Description",
      "cascade",
      "format",
      "product_Code",
      "product_Description",
      "time_Period",
      "utilization_Perc",
      "speed",
      "min_Capacity",
      "max_Capacity",
      "cpt",
      "step_1_Vol",
      "step_1_Cost",
      "step_2_Vol",
      "step_2_Cost",
      "step_3_Vol",
      "step_3_Cost",
      "step_4_Vol",
      "step_4_Cost",
      "step_5_Vol",
      "step_5_Cost",
      "lead_Time",
      "cO2",
    ];
    const allMissingFields = new Set<string>();
    getEditedValue.forEach((row: any) => {
      requiredFields.forEach((field) => {
        const value = row[field];
        if (value === undefined || value === null || value === "") {
          // Convert field name to readable format
          const fieldName = field
            .replace(/_/g, " ")
            .replace(/\b\w/g, (l) => l.toUpperCase());
          allMissingFields.add(fieldName);
        }
      });
    });

    if (allMissingFields.size > 0) {
      // Convert Set to Array and join
      const missingFieldsList = Array.from(allMissingFields).join(", ");

      setSnackbar({
        children: `Please fill the required fields: ${missingFieldsList}`,
        severity: "error",
      });
      return; // Prevent the save operation
    }

    handleClickOpen();
  };

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDeleteRows = () => {
    if (!selectedRows.length) return;
    setIsDeleteConfirmOpen(true);
  };

  const handleConfirmDeleteRows = () => {
    const updatedRows: any[] = [];
    const rowsToDelete: any[] = [];

    rowsData.forEach((row: any) => {
      if (selectedRows.includes(row.id)) {
        const updated = {
          ...row,
          folder_id: 0,
          folder_Id: 0,
          scenario_id: 0,
          isDelete: true,
        };
        rowsToDelete.push(updated);
      } else {
        updatedRows.push(row);
      }
    });

    setRows(updatedRows);

    if (rowsToDelete.length > 0) {
      // Store deleted rows separately
      setDeletedRows((prev: any[]) => [...prev, ...rowsToDelete]);

      setIsDeleteConfirmOpen(false);
      setSelectedRows([]);
      setIsActionEnabled(false);

      const dataToSave =
        getEditedValue && getEditedValue.length > 0
          ? [
              ...getEditedValue.filter(
                (row: any) => row && Object.keys(row).length > 0,
              ),
              ...rowsToDelete,
            ]
          : rowsToDelete;

      handleAgree(dataToSave, "Record deleted successfully");
    } else {
      setIsDeleteConfirmOpen(false);
    }
  };

  const handleAgree = (dataToSave: any[], successMessage: string) => {
    const transformedRows = dataToSave.map((row: any) => {
      if (row.isNew) {
        const { isNew, ...rest } = row;
        rest.id = 0;
        return rest;
      } else if (row.isDelete) {
        const { isDelete, ...rest } = row;
        rest.folder_id = 0;
        rest.Scenario_Id = 0;
        return rest;
      }

      return row;
    });
    const urls = API_BASE_URL + LONG_BULK_EDIT_PACK_PLANT_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    const payload = {
      moduleKey: Number(folderModuleName.slice(-1)),
      data: transformedRows,
    };

    putRequest(urls, payload, header, {})
      .then((response) => {
        if (response.status == 200) {
          callTableGridApi();
          setSnackbar({
            children: successMessage,
            severity: "success",
          });
          handleClose();
          //dispatch(enableEditFilter(false, "handlecat"));
          childRef?.current?.ClearEditedData();
          dispatch(EditProductTableSuccess(response.data));
        }
      })
      .catch((error) => {
        // dispatch(openErrorDialog(error));
        setSnackbar({
          children: "Something went wrong please try again!",
          severity: "error",
        });
        // dispatch(enableEditFilter(false, "handlecat"));
        handleClose();
      });
    // setTimeout(() => {
    //   props?.onClose();
    // }, 200);
  };

  // bulk edit

  const [snackbar, setSnackbar] = React.useState<Pick<
    AlertProps,
    "children" | "severity"
  > | null>(null);

  const handleCloseSnackbar = () => setSnackbar(null);

  return (
    <>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
        className="Dialogbox-display"
      >
        <DialogTitle
          id="responsive-dialog-title"
          className="responsive-dialog-title-txt"
        >
          {"Confirmation for Edit"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText className="md-alert-clr">
            {getEditedValue.length > 0
              ? "Do you want to submit the edited Packaging Plant table data?"
              : "Please Edit any value to save!"}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {getEditedValue.length > 0 ? (
            <>
              <Button className="modal-btn-b" autoFocus onClick={handleClose}>
                No
              </Button>
              <Button
                className="modal-btn-b"
                onClick={() =>
                  handleAgree(getEditedValue, "Successfully saved")
                }
                autoFocus
              >
                Yes
              </Button>
            </>
          ) : (
            <Button className="modal-btn-b" autoFocus onClick={handleClose}>
              Ok
            </Button>
          )}
        </DialogActions>
      </Dialog>
      <ConfirmationDialog
        open={isDeleteConfirmOpen}
        onClose={() => setIsDeleteConfirmOpen(false)}
        onConfirm={handleConfirmDeleteRows}
        title="Confirmation for Delete"
        page="Packaging Plant"
        confirmText="Yes"
        cancelText="No"
        fullScreen={fullScreen}
      />
      <div className="Compare">
        <div className="filter-section">
          <div className="page-title">
            <h3>Packaging Plant</h3>
          </div>
          <div className="filters">
            <span title="Reset">
              <RestoreOutlinedIcon
                className="restoreIcon"
                onClick={(e) => handleRestoreClicked(e)}
              />
            </span>
            <AddRowButton
              isEditEnabled={isEditEnabled && !isActionEnabled}
              handleAddRow={handleAddRow}
            />
            <DeleteRowsButton
              isEditEnabled={isEditEnabled && isActionEnabled}
              handleDeleteRows={handleDeleteRows}
            />
            <div className="filter-item">
              <FormControl fullWidth className="selectDropdown">
                <Select
                  id="simple-select-1"
                  value={selectPackagingPlantCode}
                  placeholder="Select Factory"
                  onChange={handlePackagingPlantCode}
                  className="select-short-term"
                  inputProps={{ "aria-label": "Without label" }}
                  displayEmpty
                >
                  <MenuItem value="">
                    <em>Packaging Plant Code</em>
                  </MenuItem>
                  {sortedPackaingPlantCode?.map((d: any) => {
                    // return (<MenuItem key={d} value={d.factory}>{d.factory}</MenuItem>)
                    return (
                      <MenuItem key={d} value={d.packaging_Plant_Code}>
                        {d.packaging_Plant_Code}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>

            <div className="filter-item">
              <FormControl fullWidth className="selectDropdown">
                <Select
                  id="simple-select-3"
                  value={selectCascade}
                  placeholder="Select Line"
                  onChange={handleCascade}
                  // renderValue={(selectLine: any) => selectLine}
                  className="select-short-term"
                  inputProps={{ "aria-label": "Without label" }}
                  displayEmpty
                >
                  <MenuItem value="">
                    <em>Cascade</em>
                  </MenuItem>
                  {cascadeOptions?.map((d: any) => {
                    return (
                      <MenuItem key={d} value={d.cascade}>
                        {d.cascade}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>

            <div className="filter-item">
              <FormControl fullWidth className="selectDropdown">
                {/* <InputLabel>Flag</InputLabel> */}
                <Select
                  id="simple-select-4"
                  value={selectProductCode}
                  placeholder="Select Basepack"
                  onChange={handleProductCode}
                  // renderValue={(selectflag: any) => selectflag}
                  className="select-short-term"
                  inputProps={{ "aria-label": "Without label" }}
                  displayEmpty
                >
                  <MenuItem value="">
                    <em>Product Code</em>
                  </MenuItem>
                  {productCodeOptions?.map((d: any) => {
                    return (
                      <MenuItem key={d} value={d.product_Code}>
                        {d.product_Code}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>

            <div className="filter-item">
              <FormControl fullWidth className="selectDropdown">
                {/* <InputLabel>Flag</InputLabel> */}
                <Select
                  id="simple-select-4"
                  value={selectTimePeriod}
                  placeholder="Select Basepack"
                  onChange={handleTimePeriod}
                  // renderValue={(selectflag: any) => selectflag}
                  className="select-short-term"
                  inputProps={{ "aria-label": "Without label" }}
                  displayEmpty
                >
                  <MenuItem value="">
                    <em>Time Period</em>
                  </MenuItem>
                  {timePeriodOptions?.map((d: any) => {
                    return (
                      <MenuItem key={d} value={d.time_Period}>
                        {d.time_Period}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>
            {isEditEnabled && isEditPopup && (
              <FormControl fullWidth>
                <div
                  className="content-save-btn"
                  onClick={(e) => handleEditSave(e)}
                >
                  <img src={btnSaveIcon} alt="" /> <span> Save</span>
                </div>
              </FormControl>
            )}

            <div className="filter-item">
              <FormControl fullWidth>
                <div
                  className={`content-download-btn ${
                    isActionEnabled ? "disabled" : ""
                  }`}
                  onClick={(e) => handleDownload(e)}
                >
                  <img src={btnDownloadIcon} alt="" /> <span> Download</span>
                </div>
              </FormControl>
            </div>
          </div>
        </div>
      </div>
      <div>
        <PackagingPlantMasterTable
          ref={childRef}
          isProcessed={isProcessed}
          rowsData={rowsData}
          handleGetEditData={handleFetchEditData}
          handleClearEditData={handleClearEditData}
          setRows={setRows}
          handleSelectionChange={handleSelectionChange}
          selectedRows={selectedRows}
        />
        {!!snackbar && (
          <Snackbar
            open
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            onClose={handleCloseSnackbar}
            autoHideDuration={6000}
          >
            <Alert {...snackbar} onClose={handleCloseSnackbar} />
          </Snackbar>
        )}
      </div>
    </>
  );
}

export default PackagingPlantMaster;
